export default __webpack_public_path__ + "static/media/viewFilter.8c3fe08c.svg";